export type ClientType = 'legal' | 'ip' | 'individual';

export const CLIENT_TYPE_TABS: { value: ClientType; label: string }[] = [
  { value: 'legal', label: 'Юрлицо' },
  { value: 'ip', label: 'ИП' },
  { value: 'individual', label: 'Физлицо' },
];

export const FUNDING_SOURCES = [
  { value: 'own', label: 'Собственные средства' },
  { value: 'budget', label: 'Госбюджет' },
] as const;

export type FundingSource = typeof FUNDING_SOURCES[number]['value'];

export const STEPS = [
  { id: 1, label: 'Выбор курса' },
  { id: 2, label: 'Слушатели' },
  { id: 3, label: 'Группа и подтверждение' },
  { id: 4, label: 'Готово' },
];

export type GroupState = 'forming' | 'open' | 'waiting';

export const GROUP_STATE_LABEL: Record<GroupState, string> = {
  forming: 'Формируется',
  open: 'Набор открыт',
  waiting: 'Ожидает открытия',
};

export interface TrainingGroup {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  state: GroupState;
}

export type PaymentMethod = 'erip' | 'card' | 'requisites';

export const PAYMENT_METHODS: { value: PaymentMethod; label: string }[] = [
  { value: 'erip', label: 'ЕРИП' },
  { value: 'card', label: 'Оплата картой' },
  { value: 'requisites', label: 'Оплата по реквизитам' },
];

export type ListenerStatus = 'not_started' | 'in_progress' | 'passed';

export const LISTENER_STATUS_LABEL: Record<ListenerStatus, string> = {
  not_started: 'Не начал',
  in_progress: 'В процессе',
  passed: 'Пройден',
};

export interface ListenerFullRow {
  id: string;
  fullNameRu: string;
  fullNameBy: string;
  address: string;
  passport: string;
  passportIssueDate: string;
  passportIssuer: string;
  externalEmail: string;
  status: ListenerStatus;
}

export interface ListenerRow {
  id: string;
  fullName: string;
  position: string;
  birthDate: string;
  phone: string;
  email: string;
}

